import { render } from 'preact';

// No font imports here any more. Both of the faces that set the page come from
// Typekit — Miller for the serif, Acumin for the sans — because Adobe's licence
// keeps their files on Adobe's servers; they are linked from `index.html`. The
// one face still ours to serve is Old Money, which sets the names and arrives
// through `styles/fonts.css` below rather than through a package.
//
// That is worth stating plainly, because it inverts what this block used to
// say. The sans sets `body`, so it is the face nearly every word on the site is
// read in, and it is now third-party. A Typekit outage no longer costs the page
// its refinement, it costs the page its text — which is what the fallback
// stacks in `tokens.css` are for, and why they are chosen by genre rather than
// by habit.

import './styles/fonts.css';
import './styles/tokens.css';
import './styles/global.css';
import './styles/sections.css';
import './styles/forms.css';
import './styles/admin.css';

import { App } from './app';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root element');
render(<App />, root);
